import { useCallback } from 'react';

import { useMarkMessageAsRead } from '@web/conversations/hooks/useMarkMessageAsRead';
import { useConversationActions } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { Message } from '@web/conversations/types/Message';

type ID = number;
type Props = {
  conversationId: ID;
  message: Message;
};

export const useMarkConversationAsReadAction = () => {
  const { setUnreadMessagesCount, setUnreadMessageMarker } = useConversationActions();
  const mutation = useMarkMessageAsRead();

  const { mutateAsync } = mutation;

  const action = useCallback(
    async (payload: Props) => {
      try {
        setUnreadMessageMarker({ message: null });
        setUnreadMessagesCount({ count: 0 });

        await mutateAsync({
          conversationId: payload.message.conversationId,
          markAllRead: true,
          messageId: payload.message.id,
        });
      } catch (e) {
        console.warn(e);
      }
    },
    [mutateAsync, setUnreadMessageMarker, setUnreadMessagesCount]
  );

  return { action, mutation };
};
